import { render, staticRenderFns } from "./PcoWorkflowTempPage.vue?vue&type=template&id=dcf1a540&scoped=true"
import script from "./PcoWorkflowTempPage.vue?vue&type=script&lang=js"
export * from "./PcoWorkflowTempPage.vue?vue&type=script&lang=js"
import style0 from "./PcoWorkflowTempPage.vue?vue&type=style&index=0&id=dcf1a540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf1a540",
  null
  
)

export default component.exports